import styled from 'styled-components';
import { Td } from '../../../../components/styles/table-style';

interface ThProps {
  $sortable?: boolean;
}

export const Th = styled.th<ThProps>`
  color: #696969;
  background-color: #f5f5f5;
  text-align: start;
  border: 0;
  font-size: .85rem;
  font-weight: 400;
  padding-left: 1.2rem;
  cursor: ${({ $sortable }) => ($sortable ? 'pointer' : 'default')};
  transition: background 0.2s;
  &:hover {
    background: ${({ $sortable }) => ($sortable ? '#f1f3f5' : '#f5f5f5')};
  }
`;

export const ConfigMenuWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  z-index: 10;
`;

export const ConfigMenuButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 6px;
  transition: background 0.2s;
  &:hover {
    background: #f5f5f5;
  }
`;

export const ColumnMenu = styled.div`
  position: absolute;
  top: 36px;
  right: 0;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
  padding: 12px;
  min-width: 180px;
  z-index: 20;
`;

export const ColumnMenuTitle = styled.strong`
  font-size: 14px;
`;

export const ColumnMenuList = styled.div`
  margin-top: 8px;
`;

export const ColumnMenuItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 4px;
  label {
    margin-left: 6px;
    font-size: 13px;
    cursor: pointer;
  }
`;

export const ThContent = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const TableContainer = styled.div`
  max-height: 70vh;
  overflow-y: auto;
  display: block;
  width: 100%;
`;

export const CenteredCell = styled(Td)`
  text-align: center;
`;

const CenteredContainer = styled.div`
  padding-top: 20px;
  text-align: center;
`;

export const MessageContainer = styled(CenteredContainer)`
  font-weight: 500;
  color: #6c757d;
`;

export const ErrorMessage = styled(MessageContainer)`
  color: var(--danger-color, #dc3545);
`;

export const StatusBadge = styled.span<{ status: boolean }>`
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;

  ${props =>
    props.status
      ? `
      background-color: #10B981;
      color: white;
      border: 1px solid #10B981;
    `
      : `
      background-color: white;
      color: black;
      border: 1px solid black;
    `}
`;